import Radium from "radium";
import React, { Component } from "react";
import { Link } from "react-router";
import { semanticColors } from "../Globals/styles";
import { httpGet } from "../Util/http";
import { connect } from 'react-redux';
import "./table.css";
import { setNavHeader } from "../MainClient/Navbar/actions";

class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      skip: 0,
      take: 25,
      query: "",
      archived: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(setNavHeader(true, "Bygherre"))
    this.query();
  }

  query(skip, take, append, archived, query = "") {
    httpGet(
      process.env.REACT_APP_webApiEndPoint +
      `api/client/searchv2?query=${query}&skip=${skip === undefined ? this.state.skip : skip
      }&take=${take === undefined ? this.state.take : take}&archived=${archived === undefined ? this.state.archived : archived
      }`
    )
      .then((res) => res.json())
      .then((resp) => {
        if (append) {
          this.setState({
            clients: [...this.state.clients, ...resp],
          });
        } else {
          this.setState({ clients: resp });
        }
      });
  }

  render() {
    return (
      <div id="clients" style={styles.page}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Link to={"/clients/create-new"}>
            <button className="btn btn-default">
              Opret bygherre
            </button>
          </Link>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", marginRight: 6 }}>
              <div
                style={styles.seeAll}
                onClick={() => {
                  this.setState({
                    archived: false,
                  });
                  this.query(
                    0,
                    this.state.take,
                    false,
                    false,
                    this.state.query
                  );
                }}
                className={
                  this.state.archived ? "btn btn-default" : "btn btn-info"
                }
              >
                Aktive
              </div>
              <div
                style={styles.seeFavorite}
                onClick={() => {
                  this.setState({
                    archived: true,
                  });
                  this.query(0, this.state.take, false, true, this.state.query);
                }}
                className={
                  !this.state.archived ? "btn btn-default" : "btn btn-info"
                }
              >
                Arkiverede
              </div>
            </div>
            <input
              value={this.state.query}
              onChange={(evt) => {
                const search = evt.target.value;
                this.query(
                  0,
                  this.state.take,
                  false,
                  this.state.archived,
                  search
                );
                this.setState({
                  query: search,
                  skip: 0,
                });
              }}
              placeholder="Søg..."
            />
          </div>
        </div>
        <div style={styles.container} className="flex-gap">
          <table style={{ margin: 6 }}>
            <thead>
              <th>Navn</th>
              <th>Kontaktpersoner</th>
              <th></th>
            </thead>
            <tbody>
              {this.state.clients.map((user) => (
                <tr key={user.aggregateId}>
                  <td>{user.name}</td>
                  <td>{(user.contacts || []).length}</td>
                  <td>
                    <Link
                      to={`clients/${encodeURIComponent(user.aggregateId)}`}
                    >
                      <button className="btn btn-primary">rediger</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={styles.indlaes}>
            <button
              onClick={() => {
                const skip = this.state.skip + this.state.take;
                this.setState({
                  skip,
                });
                this.query(
                  skip,
                  this.state.take,
                  true,
                  this.state.archived,
                  this.state.query
                );
              }}
              className="btn btn-primary"
            >
              Indlæs flere
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  page: {
    position: "absolute",
    paddingTop: "70px",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    "@media (min-width: 1200px)": {
      left: "50%",
      marginLeft: "-585px",
      maxWidth: "1170px",
    },
    overflow: "hidden",
  },
  container: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    marginTop: 24,
    backgroundColor: semanticColors.default,
    height: "100%",
    overflow: "auto",
  },
  indlaes: {
    marginBottom: 100,
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "center",
  },
  seeAll: {
    width: "50px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    marginLeft: "15px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "2px",
    borderBottomLeftRadius: "2px",
    borderBottomRightRadius: "0px",
  },
  seeFavorite: {
    width: "100px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    borderBottomLeftRadius: "0px",
  },
};
export default connect()(Radium(Clients));



// WEBPACK FOOTER //
// ./src/App/Clients/index.jsx